import BugsnagPluginReact from '@bugsnag/plugin-react';
import { clientMount } from '@vp/ubik-fragment-react';
import React from 'react';
import Bugsnag from '@bugsnag/js';
import { initialize, waitTillAvailable } from '@vp/ab-reader';
import type { MountWithRootOptions } from '@vp/ubik-fragment-types';
import { App } from '../app';
import type { Props } from '../app';

export const mount: MountWithRootOptions<Props> = async (rootElement, renderProps, rootOptions) => {
    const { localeReference, locale } = renderProps;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line no-restricted-properties
    const stringsTable = await System.import(localeReference);
    const resources = {
        [locale]: {
            translation: stringsTable,
        },
    };

    // This causes the fragment to wait until we have an active ab-reader before rendering
    initialize();
    await waitTillAvailable(1000);

    Bugsnag.start({
        apiKey: renderProps.envConfig.bugsnagApiKey,
        enabledReleaseStages: ['production'],
        releaseStage: renderProps.envConfig.bugsnagReleaseStage,
        plugins: [new BugsnagPluginReact(React)],
        onError: (event) => {
            event.addMetadata('request', {
                url: event.request.url,
                headers: event.request.headers,
            });

            event.addMetadata('debug info', {
                isUbik: 'true',
                errorLocation: typeof window === 'undefined' ? 'server' : 'client',
            });
        },
    });
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const ErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary();

    return clientMount(
        <ErrorBoundary>
            <App {...renderProps} resources={resources} />
        </ErrorBoundary>,
        rootElement,
        rootOptions
    );
};
